// import GoCat from '@/pages/GoCatPreferential/GoCatPreferential';
// import Home from '@/pages/Home/Home.vue'
// import Honest from '@/pages/HonestBusinessman/HonestBusinessman';
// import TestDrive from '@/pages/MeasurementTestDrive/MeasurementTestDrive';
// import News from '@/pages/NewsAndInformation/NewsAndInformation';
// import Personal from '@/pages/Personal/Personal';
// import SignUp1 from '@/pages/SignUp/SignUp1';
// import SignUp2 from '@/pages/SignUp/SignUp2';
// import NewsDetails from '@/pages/NewsDetails/NewsDetails';
// import GoCatDetails from '@/pages/GoCatPreferential/GoCatDetails/GoCatDetails';

// import Information from '@/pages/Information/Information';
// import MyOrder from '@/pages/MyOrder/MyOrder';
// import OrderDetails from '@/pages/OrderDetails/OrderDetails';
// import PersonalData from '@/pages/PersonalData/PersonalData';
import Login from '@/pages/Login/Login';
const GoCat = () =>
    import ("@/pages/GoCatPreferential/GoCatPreferential");
const Home = () =>
    import ("@/pages/Home/Home.vue");
const Honest = () =>
    import ("@/pages/HonestBusinessman/HonestBusinessman");
const TestDrive = () =>
    import ("@/pages/MeasurementTestDrive/MeasurementTestDrive");
const News = () =>
    import ("@/pages/NewsAndInformation/NewsAndInformation");
const Personal = () =>
    import ("@/pages/Personal/Personal");
const SignUp1 = () =>
    import ("@/pages/SignUp/SignUp1");
const SignUp2 = () =>
    import ("@/pages/SignUp/SignUp2");
const NewsDetails = () =>
    import ("@/pages/NewsDetails/NewsDetails");
const GoCatDetails = () =>
    import ("@/pages/GoCatPreferential/GoCatDetails/GoCatDetails");
const Information = () =>
    import ("@/pages/Information/Information");
const MyOrder = () =>
    import ("@/pages/MyOrder/MyOrder");
const OrderDetails = () =>
    import ("@/pages/OrderDetails/OrderDetails");
const PersonalData = () =>
    import ("@/pages/PersonalData/PersonalData");
const RefundDetails = () =>
    import ("@/pages/RefundDetails/RefundDetails");
const Review = () =>
    import ("@/pages/Review/Review");
const Enquiry = () =>
    import ("@/pages/Enquiry/Enquiry");
const About = () =>
    import ("@/pages/About/About");


export default [
    // { path: '', redirect: '/gocat' },
    { path: '/login', component: Login, meta: { showHeader: false } },
    { path: '/home', component: Home, meta: { showHeader: true } },
    { path: '/gocat', component: GoCat, meta: { showHeader: true } },
    { path: '/details/:id', component: GoCatDetails, meta: { showHeader: true } },
    { path: '/enquiry/:id', component: Enquiry, meta: { showHeader: true } },
    { path: '/newsDetails/:id', component: NewsDetails, meta: { showHeader: true } },
    { path: '/honest', component: Honest, meta: { showHeader: true }, },
    { path: '/review', component: Review, meta: { showHeader: true }, },
    { path: '/about/:id', component: About, meta: { showHeader: true }, },


    { path: '/testdrive', component: TestDrive, meta: { showHeader: true } },
    { path: '/news', component: News, meta: { showHeader: true } },
    { path: '/personal', component: Personal, meta: { showHeader: false } },
    { path: '/information', component: Information, meta: { showHeader: false } },
    { path: '/myorder', component: MyOrder, meta: { showHeader: false } },
    { path: '/orderdetails/:id', component: OrderDetails, meta: { showHeader: false } },
    { path: '/personaldata', component: PersonalData, meta: { showHeader: false } },
    { path: '/signup1/:id', component: SignUp1, meta: { showHeader: true } },
    { path: '/signup2', component: SignUp2, meta: { showHeader: true } },
    { path: '/refunddetails/:id', component: RefundDetails, meta: { showHeader: false } },

]